import * as React from 'react';
import { Modal } from 'antd';
import { ModalProps } from 'antd/es/modal';
import styled from 'styled-components';
import { ReactNode } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import theme from 'theme';

const StyledModal = styled(Modal)`
    label {
        font-weight: 500;
    }

    .ant-modal-title {
        font-size: 18px;
        font-weight: normal;
        text-align: center;
    }

    .ant-modal-body {
        padding: 30px 70px;
    }

    .ant-modal-footer {
        border: none;
        padding: 0 70px 30px 70px;

        button {
            margin-left: 30px;
        }
    }
`;

const ModalCloseButton = styled.div`
    border: none;
    background-color: transparent;
    margin-top: 6px;
    padding: 0;

    && svg {
        color: ${theme.colors.main};
        height: 25px;
        width: 25px;
    }
`;

interface Props extends ModalProps {
    children: ReactNode;
}

function CloseIcon() {
    return (
        <ModalCloseButton>
            <FontAwesomeIcon icon={['far', 'times']} />
        </ModalCloseButton>
    );
}

function ModalBase(props: Props) {
    return <StyledModal {...props} closeIcon={<CloseIcon />} width={650} />;
}

export default ModalBase;
